import React, { useRef } from "react";
import { Camera, Image as ImageIcon, X } from "lucide-react";

const ShopPhotoUpload = ({ form, setForm }) => {
    const inputRef = useRef(null);

    const fileName = form.shopPhotoFile?.name;

    const handleFileChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const previewUrl = URL.createObjectURL(file);

        setForm((prev) => ({
            ...prev,
            shopPhotoPreview: previewUrl,
            shopPhotoFile: file, // Store the File object instead of Base64
            shopPhotoFileName: file.name,
        }));
    };

    const handleReplace = (e) => {
        e.stopPropagation();
        inputRef.current?.click();
    };

    const handleRemove = (e) => {
        e.stopPropagation();
        setForm((prev) => ({
            ...prev,
            shopPhotoPreview: "",
            shopPhotoFile: null,
            shopPhotoFileName: "",
        }));
    };

    return (
        <div className="bg-white rounded-[16px] border border-[#e4e5e7] p-[24px] md:p-[32px]">

            <input
                ref={inputRef}
                type="file"
                accept="image/*"
                className="hidden"
                onChange={handleFileChange}
            />

            {/* NO IMAGE STATE */}
            {!form.shopPhotoPreview ? (
                <div
                    onClick={() => inputRef.current?.click()}
                    className="border-2 border-dashed rounded-[14px] p-[40px] md:p-[56px] flex flex-col items-center gap-[16px] cursor-pointer transition-all border-[#e4e5e7] hover:border-[#c0c2c6] bg-[#fafafa]"
                >
                    <div className="w-[64px] h-[64px] rounded-full bg-[#fff0ec] flex items-center justify-center">
                        <Camera className="w-[28px] h-[28px] text-[#ff5323]" />
                    </div>

                    <div className="text-center">
                        <p className="font-semibold text-[16px] text-[#212326] mb-[4px]">
                            Upload your shop photo
                        </p>
                        <p className="font-medium text-[13px] text-[#9298a0]">
                            Drag & drop or click to browse - JPG, PNG, WEBP
                        </p>
                    </div>
                </div>
            ) : (
                /* IMAGE UPLOADED STATE */
                <div className="flex flex-col gap-[14px]">

                    {/* IMAGE PREVIEW */}
                    <div className="relative rounded-[14px] overflow-hidden">
                        <img
                            src={form.shopPhotoPreview}
                            alt="Shop preview"
                            className="w-full h-[260px] md:h-[320px] object-cover"
                        />

                        {/* remove button */}
                        <button
                            onClick={handleRemove}
                            className="absolute top-[12px] right-[12px] w-[32px] h-[32px] rounded-full bg-black/50 flex items-center justify-center hover:bg-black/70 transition-colors"
                        >
                            <X className="w-[16px] h-[16px] text-white" />
                        </button>
                    </div>

                    {/* BOTTOM FILE BAR */}
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-[10px] min-w-0">
                            <ImageIcon className="w-[18px] h-[18px] text-[#ff5323]" />

                            <span className="font-medium text-[14px] text-[#212326] truncate max-w-[300px]">
                                {fileName || "image.png"}
                            </span>
                        </div>

                        <button
                            onClick={handleReplace}
                            className="font-semibold text-[13px] text-[#ff5323] hover:underline"
                        >
                            Replace
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ShopPhotoUpload;